module.exports = __webpack_public_path__ + "img/radio-off.ff22b455.svg";